import axios from '../axios'

export const save = (data) => {
  return axios({
      url: '/userparam/save',
      method: 'post',
      data
  })
}
export const get = (data) => {
  return axios({
      url: '/userparam/get',
      method: 'get',
      params: {
        paramName: data
      },
      data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/userparam.js